import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_SouthParkCharacterGenerator = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/south-park-character-generator',
			name: 'South Park Character Generator — Create Your Avatar | Lift',
			description:
				"Create your own South Park character instantly with Lift's AI generator. Upload a photo and turn yourself into a custom South Park avatar — no design skills needed. No watermark.",
			url: 'https://liftapp.ai/south-park-character-generator',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/south-park-character-generator#product' },
				{ '@id': 'https://liftapp.ai/south-park-character-generator#howto' },
				{ '@id': 'https://liftapp.ai/south-park-character-generator#benefits' },
				{ '@id': 'https://liftapp.ai/south-park-character-generator#faq' },
				{ '@id': 'https://liftapp.ai/south-park-character-generator#why-lift' },
				{
					'@id':
						'https://liftapp.ai/south-park-character-generator#explore-tools',
				},
				{
					'@id': 'https://liftapp.ai/south-park-character-generator#all-in-one',
				},
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/south-park-character-generator#product',
			name: 'South Park Character Generator',
			description:
				"Create your own South Park character instantly with Lift's AI generator. Upload a photo and turn yourself into a custom South Park avatar — no design skills needed.",
			url: 'https://liftapp.ai/south-park-character-generator',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/south-park-character-generator#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your image',
					text: 'Select a photo from your gallery or snap one directly in the app',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'AI builds your South Park avatar',
					text: 'Our AI transforms your features into the iconic South Park animation style — bold lines, flat colors, and signature simplicity',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Apply the transformation',
					text: 'Let AI reimagine your photo in seconds',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and share',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/south-park-character-generator#benefits',
			name: 'Who can benefit from AI South Park Character Generator?',
			description:
				"Lift's AI South Park Character Generator is perfect for fans, social media users, content creators, friends, and meme makers who want to create unique South Park-style avatars.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Die-hard fans wanting to see themselves in the South Park universe',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Social media users creating fun pics and profile banners',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Content creators designing avatars for YouTube, Twitch, or Discord overlays',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Friend groups making matching South Park OCs for chats or parties',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Meme makers remixing scenes with custom South Park characters',
				},
				{
					'@type': 'ListItem',
					position: 6,
					name: 'Event hosts and communities crafting playful invites or badges',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.3da6de53.webp',
				name: 'AI South Park Character Generator by Lift',
				description:
					'Example of how Lift AI South Park Character Generator creates custom avatars in the iconic South Park style.',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/south-park-character-generator#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI South Park Character Generator?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI South Park Character Generator is an online tool that instantly transforms your photo into a custom South Park-style avatar — perfect for social media, profile pictures, creative projects, and fun personal content.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift AI South Park Character Generator work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Our AI analyzes your photo, detects facial features, and recreates them in the iconic South Park animation style — bold lines, flat colors, and signature simplicity. Everything happens automatically — no drawing or design skills required.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I convert any photo into a South Park character?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes! Lift works with selfies, portraits, group photos, pets, or any image. The AI adapts to different photos and generates a unique South Park-style avatar that keeps the essence of the original image.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download my South Park avatar without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, ads, or e-commerce.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/south-park-character-generator#why-lift',
			name: "Why Lift's AI South Park Character Generator stands out",
			description:
				"Lift's South Park Character Generator combines professional-grade AI, ease of use, and affordability — making it a trusted choice for millions of users worldwide.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade visuals every time',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the effect to the scene and subject for optimal results',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly designers with an affordable and intuitive tool',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.ae83a89c.webp',
				name: 'Why use Lift AI South Park Character Generator',
				description:
					"Comparison of Lift's AI South Park Character Generator benefits — professional quality, AI accuracy, multi-platform access, and cost savings.",
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/south-park-character-generator#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/south-park-character-generator#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'South Park Character Generator',
					item: 'https://liftapp.ai/south-park-character-generator',
				},
			],
		},
	],
};
